"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBaseUrlPolicyIssue = appBaseUrlPolicyIssue;
/** Shared by artifact validation and the server/browser binding runtime. */
function appBaseUrlPolicyIssue(url, target = 'resource') {
    const value = url.trim();
    if (!value || value.startsWith('#'))
        return null;
    if (/[\\\u0000-\u0020\u007f]/.test(value))
        return 'URL contains unsafe characters';
    if (value.startsWith('//'))
        return 'Protocol-relative URLs are not allowed';
    // Another site, a mail address or a phone number.
    if (target === 'link' && /^(?:https?:\/\/[^/?#]|mailto:.|tel:.)/i.test(value))
        return null;
    if (/^data:/i.test(value)) {
        const media = value
            .slice(5)
            .split(',', 1)[0]
            .split(';', 1)[0]
            .toLowerCase();
        return /^(?:image\/(?:png|jpeg|webp|gif|avif)|font\/[a-z0-9.+-]+|application\/(?:x-)?font-[a-z0-9.+-]+)$/.test(media)
            ? null
            : 'Data URL media type is not allowed';
    }
    if (/^[a-z][a-z0-9+.-]*:/i.test(value))
        return 'Absolute URLs are not allowed';
    let decoded;
    try {
        decoded = decodeURIComponent(value.split(/[?#]/, 1)[0]);
    }
    catch {
        return 'Invalid URL encoding';
    }
    if (/[\\\u0000-\u0020\u007f%]/.test(decoded))
        return 'Unsafe encoded URL';
    if (decoded.startsWith('//') ||
        decoded.split('/').some(part => part === '..'))
        return 'URL traversal is not allowed';
    const normalized = decoded
        .split('/')
        .filter(part => part !== '.')
        .join('/');
    if (/^\/(?:graphql|_?api|[-])(?:\/|$)/i.test(normalized))
        return 'Platform endpoints are not allowed';
    return null;
}
